import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#134fcf",
    color: "#eeeeee",
    hoverBg: "#0E3EA4",
    hoverColor: "#ffffff",
    hoverFontWeight: "bold",
    activeBg: "#0E3EA4"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;